








import Vue from 'vue';
import _, { debounce } from 'underscore';
import { Project, Pagination } from '@/types';

import Projects from '@/components/projects';

export default Vue.extend({
  components: {
    Projects,
  },

  data() {
    return {
      query: '',
    };
  },

  computed: {
    page(): Pagination<Project> {
      return this.$store.getters['projects/page']();
    },

    projects(): Project[] {
      return _.sortBy(this.page?.data, 'region');
    },
  },

  methods: {
    search: debounce(function(this: any) {
      this.$store.dispatch('projects/fetch:all:page', { query: this.query });
    }, 500),
  },

  watch: {
    query: {
      handler() {
        this.search();
      },
      immediate: true,
    },
  },
});
